<template>
  <div class="text-xs-center">
    <v-menu
      ref="menu"
      v-model="menuOpen"
      offset-x
      :close-on-content-click="false"
      :nudge-width="335"
      :value="menu"
    >
      <v-tooltip slot="activator" left>
        <v-btn slot="activator" icon @click="open">
          <v-badge v-if="notificationsNotTriggered" color="warning">
            <span slot="badge">!</span>
            <v-icon>notifications</v-icon>
          </v-badge>
          <v-icon v-else>notifications</v-icon>
        </v-btn>
        <span>{{ $t('mainComponent.manageNotifications') }}</span>
      </v-tooltip>
      <v-card>
        <template>
          <v-list>
            <v-list-tile avatar>
              <template v-if="isAdmin">
                <v-list-tile-avatar class="sendNotification">
                  <v-tooltip bottom>
                    <v-btn
                      slot="activator"
                      icon
                      :style="{'position': 'relative', left: '-5px'}"
                      :loading="notifying === 'lunchArrived'"
                      @click="notify"
                    >
                      <v-icon color="secondary">room_service</v-icon>
                    </v-btn>
                    <span v-t="'mainComponent.lunchArrivedNotification'" />
                  </v-tooltip>
                </v-list-tile-avatar>
                <v-list-tile-avatar class="sendNotification">
                  <v-tooltip bottom>
                    <v-btn
                      slot="activator"
                      icon
                      :style="{'position': 'relative', left: '-5px'}"
                      :loading="notifying === 'orderRating'"
                      @click="rateProvider"
                    >
                      <v-icon color="secondary">rate_review</v-icon>
                    </v-btn>
                    <span v-t="'mainComponent.dishRatingsNotification'" />
                  </v-tooltip>
                </v-list-tile-avatar>
                <v-list-tile-avatar class="sendNotification">
                  <v-tooltip bottom>
                    <v-btn
                      slot="activator"
                      icon
                      :style="{'position': 'relative', left: '-5px', bottom: '2px'}"
                      :loading="notifying === 'balanceReminder'"
                      @click="balanceReminderNotify"
                    >
                      <v-icon color="secondary">mdi-wallet</v-icon>
                    </v-btn>
                    <span v-t="'mainComponent.balanceReminderNotification'" />
                  </v-tooltip>
                </v-list-tile-avatar>
              </template>
              <template v-else>
                <v-list-tile-avatar>
                  <v-icon color="secondary">notifications</v-icon>
                </v-list-tile-avatar>
              </template>
              <v-list-tile-content>
                <v-list-tile-title v-t="'mainComponent.notifications'" />
                <v-list-tile-sub-title v-t="'mainComponent.selectNotifications'" />
              </v-list-tile-content>
            </v-list-tile>
          </v-list>
          <v-divider />
          <v-list v-if="notificationsEnabled">
            <v-list-tile>
              <v-list-tile-action>
                <v-switch v-model="lunchArrived" color="secondary" @change="updateSelections" />
              </v-list-tile-action>
              <v-list-tile-title><span v-t="'mainComponent.lunchArrived'" class="grey--text" /></v-list-tile-title>
            </v-list-tile>
            <!-- <v-list-tile>
              <v-switch v-model="reminder" color="secondary" :label="$t('mainComponent.10minutesReminder')" @click.native="updateSelections"  />
            </v-list-tile> -->
            <v-list-tile>
              <v-list-tile-action>
                <v-switch v-model="fridayAdded" color="secondary" @change="updateSelections" />
              </v-list-tile-action>
              <v-list-tile-title><span v-t="'mainComponent.fridayLunchAdded'" class="grey--text" /></v-list-tile-title>
            </v-list-tile>
            <v-list-tile>
              <v-list-tile-action>
                <v-switch v-model="orderRating" color="secondary" @change="updateSelections" />
              </v-list-tile-action>
              <v-list-tile-title><span v-t="'mainComponent.orderRatingReminder'" class="grey--text" /></v-list-tile-title>
            </v-list-tile>
            <v-list-tile class="balanceThresholdContainer">
              <v-list-tile-action>
                <v-switch v-model="balanceReminder" color="secondary" @change="updateSelections" />
              </v-list-tile-action>
              <v-list-tile-title><span v-t="'mainComponent.balanceReminder'" class="grey--text" /></v-list-tile-title>
              <v-text-field
                ref="balanceThreshold"
                v-model="balanceThreshold"
                :label="$t('mainComponent.balanceTresholdField')"
                reverse
                hint="1-9999"
                persistent-hint
                prefix="€"
                class="balanceThresholdField"
                :rules="[rules.required, rules.isNumber]"
                @blur="updateThreshold()"
                @keydown="onBalanceThresholdKeyDown"
                @paste.prevent
              />
            </v-list-tile>
          </v-list>
          <div v-else>
            <v-card-title>
              <div>
                <div style="display:flex;">
                  <v-icon color="warning" class="pr-2">warning</v-icon>
                  <h3><span v-t="'mainComponent.notEnabled'" /></h3>
                </div>
                <span v-t="'mainComponent.pleaseEnable'" />
              </div>
            </v-card-title>
          </div>
        </template>
      </v-card>
    </v-menu>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import PushNotificationsService from '@/services/PushNotificationsService';
import StorageService from '@/services/StorageService';
import AuthenticationService from '@/services/AuthenticationService';
import ValidationService from '@/services/ValidationService';

export default {
  name: 'NotificationsButton',
  data() {
    return {
      menu: false,
      notifyHover: false,
      lunchArrived: true,
      reminder: true,
      fridayAdded: true,
      orderRating: true,
      balanceReminder: false,
      balanceThreshold: 10,
      notifying: null,
      notificationsEnabled: null, // if null - it's not even supported
      requestTimeout: null,
      thresholdRequestTimeout: null,
      menuOpen: false,
      rules: {
        required: ValidationService.rules.required(),
        isNumber: ValidationService.rules.isNumber(),
      },
    };
  },
  computed: {
    ...mapGetters('userInfoStore', ['userData']),

    isAdmin() {
      return AuthenticationService.isAdmin();
    },
    notificationsNotTriggered() {
      return Notification.permission === 'default';
    },
  },
  watch: {
    menuOpen(visible) {
      if (visible) {
        this.balanceThreshold = this.userData.balanceThreshold;
      }
    },
  },
  mounted() {
    let notifications = StorageService.get('notifications');
    if (!notifications) {
      StorageService.add(
        'notifications',
        JSON.stringify({
          lunchArrived: true,
          reminder: true,
          fridayAdded: true,
          orderRating: true,
          balanceReminder: false,
        }),
      );
      notifications = StorageService.get('notifications');
    }

    const notificationsObject = JSON.parse(notifications);

    this.lunchArrived = notificationsObject.lunchArrived !== undefined ? notificationsObject.lunchArrived : true;
    this.reminder = notificationsObject.reminder !== undefined ? notificationsObject.reminder : true;
    this.fridayAdded = notificationsObject.fridayAdded !== undefined ? notificationsObject.fridayAdded : true;
    this.orderRating = notificationsObject.orderRating !== undefined ? notificationsObject.orderRating : true;
    this.balanceReminder = notificationsObject.balanceReminder !== undefined ? notificationsObject.balanceReminder : false;

    StorageService.add(
      'notifications',
      JSON.stringify({
        lunchArrived: this.lunchArrived,
        reminder: this.reminder,
        fridayAdded: this.fridayAdded,
        orderRating: this.orderRating,
        balanceReminder: this.balanceReminder,
      }),
    );
  },
  methods: {
    ...mapActions('userInfoStore', ['updateUserData']),
    async open() {
      this.notificationsEnabled = await PushNotificationsService.initialize();
      this.$forceUpdate();
      setTimeout(() => this.$refs.menu.calcLeft(), 100);
    },
    async notify() {
      this.notifying = 'lunchArrived';
      await PushNotificationsService.notifyLunchArrived();
      this.notifying = null;
      this.menu = false;
    },
    async rateProvider() {
      this.notifying = 'orderRating';
      await PushNotificationsService.notifyLunchRate();
      this.notifying = null;
      this.menu = false;
    },
    async balanceReminderNotify() {
      this.notifying = 'balanceReminder';
      await PushNotificationsService.notifyBalanceReminder();
      this.notifying = null;
      this.menu = false;
    },
    updateSelections() {
      if (this.requestTimeout) {
        clearTimeout(this.requestTimeout);
      }

      this.requestTimeout = setTimeout(() => {
        const notifications = {
          lunchArrived: this.lunchArrived,
          reminder: this.reminder,
          fridayAdded: this.fridayAdded,
          orderRating: this.orderRating,
          balanceReminder: this.balanceReminder,
        };
        StorageService.add('notifications', JSON.stringify(notifications));
        PushNotificationsService.updateSubscription();
      }, 3000);
    },
    updateThreshold() {
      clearTimeout(this.thresholdRequestTimeout);
      if (this.$refs.balanceThreshold.validate()) {
        this.thresholdRequestTimeout = setTimeout(() => {
          this.updateUserData({
            balanceThreshold: this.balanceThreshold,
          });
        }, 500);
      }
    },
    onBalanceThresholdKeyDown(event) {
      ValidationService.validateNumberInput(event, 4);
    },
  },
};
</script>
<style scoped>
.sendNotification {
  min-width: 40px
}

.balanceThresholdField {
  max-width: 100px;
}

.balanceThresholdField >>> .v-text-field__details {
  text-align: right;
}

.balanceThresholdContainer {
  min-height: 60px;
}
</style>
